import { gql } from "generated-graphql";

gql(`
  fragment LineItem on WasteLineUnified {
    id
    processedManifestId
    shippedDate
    manifestTrackingNumber
    wasteLineNumber
    willNotReport
    wasteStreamWillNotReport
    manuallyEdited
    availableSources
    primarySource
    fieldSources {
      field
      source
      value
    }
    epaId
    facility {
      id
      name
      streetAddress1
      city
      state
      zip
    }
    
    vendorAmount
    eManifestAmount
    documentAmount
    profileNumber
    lineItem
    dotDescription
    vendorDotDescription
    eManifestDotDescription
    federalWasteCodes
    stateWasteCodes
    wasteStream
    vendor
    destinationFacilityName
    isEManifest
    managementMethodCode
    vendorManagementMethodCode
    eManifestManagementMethodCode
    documentManagementMethodCode
    managementMethodDescription
    formCode
    formCodeDescription
    sourceCode
    sourceCodeDescription
    dotIdNumberDescription
    wasteMinimizationCode
    consentNumber
    dotHazardous
    epaWaste
    wasteResidue
    comments

    originalVendorProfileDescription
    originalVendorDotPrintedInformation
    originalVendorNonHazWasteDescription
    originalVendorAmount
    originalVendorProfileNumber
    originalVendorManagementMethodCode
    originalVendorFormCode
    originalVendorSourceCode

    unresolvedDiscrepancyCount
    pendingDiscrepancyCount
    discrepancyTally {
      complianceTotal
      missingEManifest
      epaCorrection
      fieldTotal
      fieldUnresolved
      fieldPending
      fieldResolved
    }

    tags {
      ...TagPicker
    }
  }
`);

gql(`
  fragment OriginalVendorWasteLine on WasteLineUnified {
    id
    originalVendorWasteLine {
      quantity
      vendorProfileNumber
      vendorProfileDescription
      dotPrintedInformation
      nonHazWasteDescription
      managementMethodCode
      tags {
        ...TagPicker
      }
    }
  }
`);

export const WASTE_LINES_UNIFIED_QUERY = gql(`
  query WasteLinesUnified($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!], $includeOriginalVendorWasteLine: Boolean = false) {
    wasteLinesUnified(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      items {
        ...LineItem
        ...OriginalVendorWasteLine @include(if: $includeOriginalVendorWasteLine) 
      }
      count
    }
  }
`);

export const WASTE_LINES_UNIFIED_COUNT_QUERY = gql(`
  query WasteLinesUnifiedCount($search: String, $page: Int, $pageSize: Int, $sort: [SortModel!]) {
    wasteLinesUnified(search: $search, page: $page, pageSize: $pageSize, sort: $sort) {
      count
    }
  }
`);

export const WASTE_LINES_UNIFIED_BULK_UPDATE_MUTATION = gql(`
  mutation wasteLinesUnifiedBulkUpdateWillNotReport(
    $input: wasteLinesUnifiedBulkUpdateWillNotReportInput!
  ) {
    wasteLinesUnifiedBulkUpdateWillNotReport(input: $input)
  }
`);

export const EDIT_WASTE_LINE_UNIFIED_MUTATION = gql(`
  mutation EditWasteLineUnified($id: String!, $input: WasteLineUnifiedInput!) {
    editWasteLineUnified(id: $id, input: $input) {
      ...LineItem
    }
  }
`);

export const DELETE_WASTE_LINE_UNIFIED_MUTATION = gql(`
  mutation deleteWasteLineUnifiedVendorData($id: String!) {
    deleteWasteLineUnifiedVendorData(id: $id) 
  }
`);
